module.exports = __webpack_public_path__ + "img/QR_wechat.d95ae05c.png";